import { mensagemAmigavel } from '@/lib/mensagemAmigavel';

export function mensagemBanco(e: unknown): string {
  return mensagemAmigavel(e, 'Não conseguimos concluir. Tente de novo.');
}